import axios from '../../axios/index.js'

export default{
    changeInvoiceHold(data){
        return axios.post('changeInvoiceHold',data)      
    },
    publish(data){
        return axios.post('invoice/publish',data)      
    }
}